import { useEffect, useState } from "react";

import { useCopyToClipboard } from "usehooks-ts";
import { Button as MuiButton, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import styled from "styled-components";
import { request } from "../utils/axios-utils";
import { Loader } from "../components/UI/Loader";
import { useTranslation } from "react-i18next";

type IKeys = {
  domain_key: string;
  domain_name: string;
  domain_open_key: string;
  id: number;
};

const SetupKey = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IKeys>();
  const navigate = useNavigate();

  const { id }: any = useParams();

  useEffect(() => {
    request({
      url: `api/v2/project/keys?id=${id}`,
    }).then((res): any => {
      setData(res.data);
    });
  }, [id]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, copy] = useCopyToClipboard();

  return (
    <Container>
      <div className="top_box">
        <p>{t("controlPanelKeysPageHeader")}</p>
      </div>
      <div className="box">
        <h1>{t("controlPanelKeysPageTitle")}</h1>
        {data ? (
          <>
            <KeyBlock>
              <KeyTitle>{t("controlPanelKeysPagePublicKeyInfo")}</KeyTitle>
              <div className="key_copy">
                <Button
                  variant="text"
                  onClick={() => copy(data.domain_open_key)}
                >
                  {t("controlPanelKeysPagePublicKeyInfoButton")}
                </Button>
                <TextField
                  aria-readonly
                  value={data.domain_open_key}
                  fullWidth
                />
              </div>
            </KeyBlock>
            <KeyBlock>
              <KeyTitle>{t("controlPanelKeysPageSecretKeyInfo")}</KeyTitle>
              <div className="key_copy">
                <Button variant="text" onClick={() => copy(data.domain_key)}>
                  {t("controlPanelKeysPageSecretKeyInfoButton")}
                </Button>
                <TextField aria-readonly value={data.domain_key} fullWidth />
              </div>
            </KeyBlock>
          </>
        ) : (
          <Loader />
        )}
        <Button onClick={() => navigate("/panel")} variant="contained">
          {t("controlPanelKeysPageButton")}
        </Button>
      </div>
    </Container>
  );
};

export default SetupKey;

const Button = styled(MuiButton)`
  width: 200px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-size: 20px;
    font-weight: 400;
  }

  .top_box {
    max-width: 48rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border: none;
    outline: none;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    color: #121212;
    background: #9bc2e0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }

    p {
      font-size: 16px;
    }
  }

  .box {
    max-width: 48rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 2rem 2.5rem;
    flex-direction: column;
    gap: 20px;
    border: none;
    outline: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }
`;

const KeyTitle = styled.p`
  font-size: 16px;
`;

const KeyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  .key_copy {
    display: flex;
    align-items: center;
    gap: 20px;
  }
`;
